/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Application_History_TitleInputs */

const en_application_history_title = /** @type {(inputs: Application_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application change history`)
};

const de_application_history_title = /** @type {(inputs: Application_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungsverlauf Bewerbung`)
};

/**
* | output |
* | --- |
* | "Application change history" |
*
* @param {Application_History_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const application_history_title = /** @type {((inputs?: Application_History_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Application_History_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_application_history_title(inputs)
	return en_application_history_title(inputs)
});